import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Barber from './Barber';
import PaymentSummary from '../containers/PaymentSummary';
import TipButton from './TipButton';
import CustomTip from '../containers/CustomTip';
import SelectPayment from './SelectPayment';
import Fullscreen from '../../../common/Fullscreen';
import Icon, { GLYPHS } from '../../../common/icon';
import OverlaySpinner from '../../../common/OverlaySpinner';
import WebReaderLoader from './WebReaderLoader';
import { t } from '../../../../modules/infra/i18n';

class Tipping extends Component {
  static propTypes = {
    payWithTip: PropTypes.func.isRequired,
    payNoTip: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
    availableBarberTips: PropTypes.arrayOf(PropTypes.object).isRequired,
    currentBarber: PropTypes.shape({
      priceForTip: PropTypes.number,
    }).isRequired,
    previousClick: PropTypes.func.isRequired,
    previousBarber: PropTypes.shape({
      priceForTip: PropTypes.number,
    }),
    nextClick: PropTypes.func.isRequired,
    nextBarber: PropTypes.shape({
      priceForTip: PropTypes.number,
    }),
    setTip: PropTypes.func.isRequired,
    cancelTipping: PropTypes.func.isRequired,
    payments: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })).isRequired,
    selectedPayment: PropTypes.string.isRequired,
    onPaymentChange: PropTypes.func.isRequired,
    giftCardPaymentSelected: PropTypes.bool.isRequired,
    cashTipsEnabled: PropTypes.bool.isRequired,
    paymentBalance: PropTypes.number,
    isProcessing: PropTypes.bool.isRequired,
    isReaderPayment: PropTypes.bool.isRequired,
    webreaderPaymentStatus: PropTypes.string,
    getTippingDisabled: PropTypes.func.isRequired,
    title: PropTypes.string,
    showSummary: PropTypes.bool,
  }
  static defaultProps = {
    customEnabled: false,
    customValue: 0,
    onChange: () => null,
    onSubmit: () => null,
    disabled: false,
    previousBarber: null,
    nextBarber: null,
    paymentBalance: null,
    webreaderPaymentStatus: '',
    title: null,
    showSummary: true,
  }

  getCashTipButtonLabel() {
    if (this.props.cashTipsEnabled && !this.props.isReaderPayment) return t('register:tipping.none_button');
    return t('register:tipping.cash_tip_none_button');
  }

  render() {
    return (
      <Fullscreen>
        <div className="o-center-page">
          <div className="c-tipping-view">

            <div className="c-tipping-view__back-btn">
              <button type="button" className="c-btn c-btn--blank" onClick={this.props.cancelTipping}>
                <Icon glyph={GLYPHS.chevronLeftBold} size="small" />
              </button>
            </div>

            <OverlaySpinner
              className="u-position-absolute"
              display-if={this.props.isProcessing && !this.props.isReaderPayment}
            />

            <WebReaderLoader />

            <div className="c-tipping-view__heading">{this.props.title || t('register:tipping.default_title')}</div>
            <div className="c-tipping-view__barbers u-mb+">
              <Barber barber={this.props.previousBarber} onClick={this.props.previousClick} faded />

              <Barber barber={this.props.currentBarber} />

              <Barber barber={this.props.nextBarber} onClick={this.props.nextClick} faded />
            </div>

            <div className="c-tipping-view__panel">
              <div className="u-mb" display-if={this.props.payments.length > 1}>
                <SelectPayment
                  payments={this.props.payments}
                  value={this.props.selectedPayment}
                  onChange={this.props.onPaymentChange}
                  disabled={this.props.disabled}
                  currentBarber={this.props.currentBarber}
                />
              </div>

              <div className="c-tipping-view__buttons">
                {this.props.availableBarberTips.map(tip => (
                  <TipButton
                    key={tip.percentage}
                    amount={tip.amount}
                    label={tip.label}
                    onClick={this.props.payWithTip(tip.amount)}
                    disabled={this.props.getTippingDisabled(tip.amount)}
                  />
                ))}

                <CustomTip
                  paymentBalance={this.props.paymentBalance}
                  disabled={this.props.getTippingDisabled()}
                  setTip={this.props.setTip}
                />

                <TipButton
                  label={this.getCashTipButtonLabel()}
                  onClick={this.props.payNoTip}
                  disabled={this.props.disabled}
                />
              </div>
            </div>

            <div className="u-mt- zeta">
              <em display-if={this.props.giftCardPaymentSelected}>{t('register:tipping.gift_card_excess_message')}</em>
            </div>

            <div className="u-mv+">
              <PaymentSummary display-if={this.props.showSummary} />
            </div>
          </div>
        </div>
      </Fullscreen>
    );
  }
}

export default Tipping;
